import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { MonetizationManager } from "@/features/admin/components/monetization-manager";
import { PageContainer } from "@fleet/ui";

function AdminMonetizationPage() {
  return (
    <PageContainer maxWidth="4xl">
      <MonetizationManager />
    </PageContainer>
  );
}

export const adminMonetizationRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/monetization",
  component: AdminMonetizationPage,
});
